import { useParams } from "react-router-dom";
import useJobPostCater from "@frontend/app/hooks/UseJobPostCater.ts";
import JobCaterEditor from "@frontend/app/catering/editing/JobCaterEditor.tsx";

const JobCaterDisplay = () => {
  const { postID } = useParams();

  const { data: cater, isLoading, error } = useJobPostCater(postID as string);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  return (
    <div className="mt-3 glass p-4">
      <h1>Hello {cater.company}!</h1>
      <br />
      <p className="text-left">
        I found your job posting for a <b>{cater.position}</b> and I'd like to show you how my
        skills line up with your requirements.
      </p>
      <p>
        Below is your job posting with some comments going over my experience and how it compares to
        what you're looking for. Please let me know if you have any questions - I'm looking forward
        to hearing from you!
      </p>
      <br />
      <JobCaterEditor
        docID={cater._id}
        content={cater.requirementsComparison}
        onUpdate={() => {}}
        comments={cater.comments}
        onCommentsUpdated={() => {}}
        onCommentAdded={() => Promise.resolve()}
        onCommentDeleted={() => {}}
        onSave={() => Promise.resolve()}
        editable={false}
        onCommentEdit={() => Promise.resolve()}
      />
    </div>
  );
};

export default JobCaterDisplay;
